"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var paginatorTheme = function paginatorTheme(theme) {
  return {
    appearance: {
      primary: {
        stepBorder: "".concat(theme.border.width[2], " ").concat(theme.border.style[1], " ").concat(theme.color.monochrome6["default"]),
        stepBgColor: 'transparent',
        currentStep: {
          bgColor: theme.color.monochrome6["default"],
          color: theme.color.monochrome1["default"],
          border: 'none'
        }
      }
    }
  };
};

var _default = paginatorTheme;
exports["default"] = _default;
//# sourceMappingURL=Paginator.theme.js.map